var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanOverviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.60156,
    width: 18.3996,
    height: 3.19465,
    rx: 1,
    fill: "#2B3A54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.09375,
    y: 5.13281,
    width: 11.1399,
    height: 3.10645,
    rx: 1,
    fill: "#2B3A54"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.25781,
    y: 10.2812,
    width: 6.67445,
    height: 3.10645,
    rx: 1,
    fill: "#2B3A54"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 15.3984,
    width: 10.3561,
    height: 3.10645,
    rx: 1,
    fill: "#2B3A54"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 13.5,
    r: 5.5,
    fill: "#2B3A54"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanOverviewIcon);
export default __webpack_public_path__ + "static/media/PlanOverviewIcon.f16c7a8d6ca6e103277964eb291c2483.svg";
export { ForwardRef as ReactComponent };